function prettyFloat( n ) {

  if ( !n ) {
    console.error('prettyFloat: передан undefined или null');
    return '0';
  }

  return ( !n.toString()?.split('.')?.[ 1 ] || +( n.toString()?.split('.')?.[ 1 ] ) === 0 )
    ? n.toString().split('.')[ 0 ] 
    : ( +n ).toFixed( 2 );

}

export default prettyFloat;